module.exports = __webpack_public_path__ + "613b6407e4997fec9a625c6f54d78292.png";